/**
 * Render-only flow views used by the PNG exporters in `exportImage.tsx`.
 *
 * These live in their own file (not inline in `exportImage.tsx`) so the exporter
 * module stays a pure utility module — mixing React components with utility
 * exports in one file breaks Vite/react-refresh Fast Refresh boundaries.
 *
 * Classic JSX runtime (app-wide esbuild transform) needs React in scope.
 */
import React from 'react';
import EdgFlow from './EdgFlow';
import FsmFlow from './FsmFlow';
import type { Notation } from './ObjectTypeNode';

/**
 * Off-screen EDG: render-only EdgFlow with zoom pinned to 1 and no fit, so the
 * graph paints 1:1 and `measureContentBounds` reads true pixel extents.
 */
export function ExportEdg({
  model,
  notation,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  notation: Notation;
}) {
  return (
    <EdgFlow
      model={model}
      notation={notation}
      ui={null}
      interactive={false}
      exportMode
    />
  );
}

/** Off-screen FSM: render-only FsmFlow at zoom 1. */
export function ExportFsm({
  fsmView,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fsmView: any;
}) {
  return <FsmFlow fsmView={fsmView} interactive={false} exportMode />;
}
